// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1tZXB","insightsList":"newBusinessInsightsMenu_insightsList__2euB6","active":"newBusinessInsightsMenu_active__1zUPp"};